import React from "react"
import { getImportTypeDefinition } from "utils/dataImportType"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { CustomServerSideReactTable } from "components/utility"
import { GET_CATEGORIES, DELETE_CATEGORY, SUM_CATEGORIES } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const CategoryListContainer = (props) => {
  useBread({ to: props.match.url, name: "類別清單" }, true)

  const fieldsDefinitions = () => {
    return [
      {
        Header: "名稱",
        style: columStyle,
        accessor: "name"
      },
      {
        Header: "子類別數量",
        style: columStyle,
        accessor: "subcategories",
        width: 100,
        Cell: (cell) => {
          return (
            <div>
              {
                cell.row?.subcategories?.filter(
                  (item) => item.isEnable === true
                ).length
              }
            </div>
          )
        }
      },
      {
        Header: "是否啟用",
        style: columStyle,
        accessor: "isEnable",
        width: 100,
        Cell: (cell) => {
          return cell.row?.isEnable ? "是" : "否"
        }
      }
    ]
  }

  return (
    <CustomServerSideReactTable
      queryObjectGql={GET_CATEGORIES}
      sumTotalQueryObjectGql={SUM_CATEGORIES}
      deleteObjectGql={DELETE_CATEGORY}
      objectName="類別"
      objectRoute={props.match.url}
      hasCreateButton={true}
      hasEditButton={true}
      hasDeleteButton={false}
      fieldsDef={fieldsDefinitions()}
      columStyle={columStyle}
      hasUploadButton={true}
      uploadSettings={getImportTypeDefinition("CATEGORYSUBCATEGORY")}
    />
  )
}

const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(CategoryListContainer)
